import React, { useEffect, useState } from "react";
import LandingHeader from "../Components/LandingHeader";
import { Container } from "react-bootstrap";
import Select from "react-select";
import { Images } from "../Components/Images";
import InnerFooter from "../Components/InnerFooter";
import { AddSupportTicket } from "../actions/markets";
import toast, { Toaster } from "react-hot-toast";
import { getAccount } from "../Hooks/useAccount";
import { useNavigate } from "react-router-dom";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";
const TicketManagement = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    address: "",
    subject: "",
    email: "",
    description: "",
    severity: "",
  });

  const options = [
    { value: "high", label: "High" },
    { value: "medium", label: "Medium" },
    { value: "low", label: "Low" },
  ];

  const [selectedOption, setSelectedOption] = useState();
  const [Error, setError] = useState({});
  const user = getAccount();

  useEffect(() => {
    setFormData({ ...formData, address: user });
  }, [user]);

  const onsubmit = async () => {
    try {
      console.log("onsubmit...", formData);
      var error = {};

      var isValid = Object.entries(formData).map(([key, value]) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (key === "email") {
          if (!value) {
            error[key] = "This field can't be empty.";
            return false;
          }
          if (!regex.test(value)) {
            error[key] = "Invalid Email";
            return false;
          }
        }
        if (value.trim() === "") {
          error[key] = "This field can't be empty.";
          return false;
        }
        return true;
      });

      setError({ ...Error, ...error });

      console.log("isValid", isValid, Error, error);
      if (!isValid.includes(false)) {
        const createSupportTicket = await AddSupportTicket(formData);
        console.log(
          "createSupportTicket",
          createSupportTicket,
          createSupportTicket.status,
          createSupportTicket.status === "success"
        );
        let { status, message, result } = createSupportTicket;
        if (true) {
          toast.success(message);
          navigate("/supportTicket");
        }
      } else {
        toast.error("Please fill all the details");
      }
    } catch (err) {
      console.log("eeee", err);
    }
  };

  const handleChange = (e) => {
    console.log("eeee", e);
    setError({});

    const { name, value } = e.target;
    console.log("formData", formData, name, value);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const styles = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#fff",
      background: isFocused
        ? "#00ddeb"
        : isSelected
          ? "#00ddeb"
          : isHovered
            ? "5fe44b"
            : "#00ddeb",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#00ddeb"
          : isSelected
            ? "#00ddeb"
            : isFocused
              ? "#00ddeb"
              : "#151515",
        cursor: "pointer",
        color: isHovered
          ? "#000"
          : isSelected
            ? "#000"
            : isFocused
              ? "#000"
              : "#fff",
        fontSize: "13px",
      };
    },
    indicatorSeparator: (styles) => ({ display: "none" }),
    valueContainer: (provided, { isFocused, isSelected, isHovered }) => ({
      ...provided,
      height: "37px",
      //   border: "1px solid #e3e0e0",
      backgroundColor: isHovered
        ? "transperant"
        : isSelected
          ? "transperant"
          : isFocused
            ? "transperant"
            : "#212930",
      // border: "1px solid rgba(34, 34, 34, 0.32)",
      borderRadius: 5,
      fontSize: "13px",
      color: "#fff",
    }),
    control: (provided, { isFocused, isSelected, isHovered }) => ({
      ...provided,
      height: "40px",
      //   border: "1px solid #00CABA",
      borderRadius: 5,
      backgroundColor: isHovered
        ? "transperant"
        : isSelected
          ? "transperant"
          : isFocused
            ? "transperant"
            : "transperant",
      // backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
      color: "#fff",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#fff",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#fff",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
      borderRadius: "5px",
    }),
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Container fluid className="p-0 position-relative common_bg">
        {/* <img
          src={Images.radiantBlur}
          className="home__dashboardLeftBlur img-fluid"
          alt=""
        />
        <img
          src={Images.radiantBlur}
          className="home__dashboardRightBlur img-fluid"
          alt=""
        /> */}
        {/* <LandingHeader /> */}
        <Header />
        <Container fluid className="p-0 custom_container">
          <Container className="home__indexAligner innerpages_ui">
            <div className="plans__holder">
              <h4 className="m-0 hebrew_bold opportunity__title">
                Ticket Management
              </h4>
              <div className="dashboard__blueBox p-4 rounded-2 h-100 mt-5">
                <h4 className="m-0 hebrew_bold dashboard__midGrad">
                  Sector-8
                </h4>
                <div className="ticketManage__quizHolder mt-4">
                  <div className="ticketManage__singleQuiz mb-3">
                    <p className="m-0 hebrew_font ticketManage__question">
                      1. Enter the Email
                    </p>

                    <input
                      type="text"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter email"
                      className="ticketManage__input hebrew_font w-100 rounded-1 mt-2"
                    />
                    {Error?.email && (
                      <span style={{ color: "red" }}>{Error?.email}</span>
                    )}
                  </div>

                  {/* <div className='ticketManage__singleQuiz mb-3'>
                      <p className='m-0 hebrew_font ticketManage__question'>1.Enter the Transaction hash</p>

                      <input type='text' className='ticketManage__input hebrew_font w-100 rounded-1 mt-2' />
                  </div> */}

                  <div className="ticketManage__singleQuiz mb-3">
                    <p className="m-0 hebrew_font ticketManage__question">
                      2. Enter the severity type
                    </p>

                    <Select
                      value={selectedOption}
                      onChange={(selected) =>
                        setFormData({ ...formData, severity: selected.value })
                      }
                      placeholder="select the severity type"

                      options={options}
                      styles={styles}
                      classNamePrefix="ticketmanagement"
                      className="mt-2"
                    // menuIsOpen
                    />
                    {Error?.severity && (
                      <span style={{ color: "red" }}>{Error?.severity}</span>
                    )}
                  </div>

                  <div className="ticketManage__singleQuiz mb-3">
                    <p className="m-0 hebrew_font ticketManage__question">
                      3. Subject
                    </p>

                    <input
                      type="text"
                      name="subject"
                      placeholder="Enter Subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="ticketManage__input hebrew_font w-100 rounded-1 mt-2"
                    />
                    {Error?.subject && (
                      <span style={{ color: "red" }}>{Error?.subject}</span>
                    )}
                  </div>

                  <div className="ticketManage__singleQuiz mb-3">
                    <p className="m-0 hebrew_font ticketManage__question">
                      4. Describe your issue in detail
                    </p>

                    <textarea
                      className="ticketManage__input hebrew_font w-100 rounded-1 mt-2"
                      name="description"
                      value={formData.description}
                      placeholder="Enter your issue in detail"
                      onChange={handleChange}
                      rows="5"
                      cols="50"
                    ></textarea>
                    {Error?.description && (
                      <span style={{ color: "red" }}>{Error?.description}</span>
                    )}
                  </div>

                  <div className="text-center mt-5">
                    <button
                      className="primary_grad_btn primary_gradBtnWidth rounded-5"
                      onClick={onsubmit}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Container>
        {/* <InnerFooter /> */}
        <NewFooter />
      </Container>
    </>
  );
};

export default TicketManagement;
